import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        tagsView,
        auth,
    },
})
